export enum MetalsProductType {
	Intermediate = 'Intermediate',
	Finished = 'Finished',
}
